import { LatestUpdateBook } from './LatestUpdateBook'
import { withLatestUpdateBook } from './withLatestUpdateBook'

const ConnectedRecommendedArticle = withLatestUpdateBook(LatestUpdateBook)

export { ConnectedRecommendedArticle as LatestUpdateBook }
